import React, { useEffect, useState } from 'react';
import { Megaphone } from 'lucide-react';
import api from '../services/api';

// Rotating platform announcements — cycles every 7 seconds.
export const AnnouncementTicker = () => {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    api.get('/announcements').then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 7000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  const current = items[idx % items.length];

  return (
    <div className="bg-emerald-700 text-white" data-testid="announcement-ticker">
      <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-2.5 text-sm">
        <Megaphone className="h-4 w-4 shrink-0 opacity-80" />
        <span key={current.id} className="animate-in fade-in duration-500 truncate" data-testid="announcement-ticker-text">
          {current.text}
        </span>
        {items.length > 1 && (
          <span className="ml-auto text-[10px] opacity-70 shrink-0">{(idx % items.length) + 1}/{items.length}</span>
        )}
      </div>
    </div>
  );
};

export default AnnouncementTicker;
